import React, { Fragment } from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';

import { Tooltip, Spacer, Icon } from '@ontruck/orc';

const StopCommentsStyled = styled(Spacer)`
  color: var(--greyWolf);
  height: ${(props) => props.theme.base.gridSizes.S};
  line-height: normal;
  > * {
    height: ${(props) => props.theme.base.gridSizes.S};
  }
`;

const StopComments = React.memo(({ comments = [], ...props }) =>
  comments.length ? (
    <StopCommentsStyled {...props}>
      <Tooltip
        component={
          <Fragment>
            {comments.map((comment, key) => (
              <div key={key}>{comment}</div>
            ))}
          </Fragment>
        }
        position="left"
        skin="light"
      >
        <Icon glyph="comments" size="1.6rem" color="grey300" />
      </Tooltip>
    </StopCommentsStyled>
  ) : null
);

StopComments.propTypes = {
  comments: PropTypes.array,
};

StopComments.defaultProps = {
  comments: [],
};

export default StopComments;
